import api from '@/services/api';

const STORAGE_KEY = '@GSCMX-PC:company-permissions';

function filterCustomerCompanies(companies) {
  return (companies || []).filter((company) => company.customer && !company.customBroker);
}

export async function loadUserCompanyPermissions(userId, companies) {
  const customerCompanies = filterCustomerCompanies(companies);

  if (!userId || customerCompanies.length === 0) {
    return {};
  }

  const responses = await Promise.all(
    customerCompanies.map((company) => api.get('/customers-portal/user-company-permissions', {
      params: {
        userId,
        customerId: company.id,
      },
    })),
  );

  const companyPermissions = {};

  customerCompanies.forEach((company, index) => {
    const data = responses[index].data.data || {};
    companyPermissions[String(company.id)] = {
      portalAdmin: Boolean(data.portalAdmin),
      permissions: data.permissions || [],
    };
  });

  return companyPermissions;
}

export function readStoredCompanyPermissions() {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (!stored) {
    return {};
  }

  try {
    return JSON.parse(stored);
  } catch {
    return {};
  }
}

export function persistCompanyPermissions(companyPermissions) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(companyPermissions));
}

export function clearStoredCompanyPermissions() {
  localStorage.removeItem(STORAGE_KEY);
}

export { STORAGE_KEY };
